import { ref } from "vue";

export type DialogType = "success" | "error" | "info" | "confirm";

interface DialogState {
  visible: boolean;
  type: DialogType;
  title: string;
  message: string;
}

const state = ref<DialogState>({
  visible: false,
  type: "info",
  title: "",
  message: "",
});

let resolvePromise: ((value: boolean) => void) | null = null;

export default function useDialog() {
  function showDialog(
    message: string,
    options?: { type?: DialogType; title?: string },
  ): Promise<boolean> {
    const type = options?.type ?? "info";
    const title =
      options?.title ??
      (type === "success" ? "Success" : type === "error" ? "Error" : type === "confirm" ? "Confirm" : "Notice");

    state.value = { visible: true, type, title, message };

    return new Promise<boolean>((resolve) => {
      resolvePromise = resolve;
    });
  }

  function closeDialog(result: boolean = true) {
    state.value = { ...state.value, visible: false };
    if (resolvePromise) {
      resolvePromise(result);
      resolvePromise = null;
    }
  }

  return { dialogState: state, showDialog, closeDialog };
}
